/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {SpeciesTableDeltaColumn} from "./SpeciesTableDeltaColumn";
import {usePrimeCache} from "../../../../../Hooks/ServiceHooks";


export const ServiceDrivenTableDeltaColumn = (props) => {
    const {service, modifiedId, nonModifiedId, insteadOfLabel, iconComponent } = props?.Value ?? {};
    
    usePrimeCache([service]);
    
    const modifiedValue = service?.GetTitle(service?.CachedValueById(modifiedId)?.result);
    const nonModifiedValue = service?.GetTitle(service?.CachedValueById(nonModifiedId)?.result);

    return <SpeciesTableDeltaColumn
        {...{
            ...props,
            Value: {
                ...(props?.Value),
                modifiedValue,
                nonModifiedValue
            }
        }} 
    />;
};


